import n from "./highrise994.mjs";
import { scaleColor as a, rgba as s, composite as c } from "./highrise993.mjs";
const r = {
  neutralBase: "#FFF",
  neutralInvertBase: "#000",
  neutralTextBase: "#000",
  neutralPopover: "#fff",
  neutralCard: "#fff",
  neutralModal: "#fff",
  neutralBody: "#fff",
  alpha1: "0.82",
  alpha2: "0.72",
  alpha3: "0.38",
  alpha4: "0.24",
  // disabled text, placeholder, icon
  alpha5: "0.18",
  // disabled placeholder
  alphaClose: "0.6",
  alphaDisabled: "0.5",
  alphaAvatar: "0.2",
  alphaProgressRail: ".08",
  alphaInput: "0",
  alphaScrollbar: "0.25",
  alphaScrollbarHover: "0.4",
  // primary
  primaryHover: "#36ad6a",
  primaryDefault: "#18a058",
  primaryActive: "#0c7a43",
  primarySuppl: "#36ad6a",
  // info
  infoHover: "#4098fc",
  infoDefault: "#2080f0",
  infoActive: "#1060c9",
  infoSuppl: "#4098fc",
  // error
  errorHover: "#de576d",
  errorDefault: "#d03050",
  errorActive: "#ab1f3f",
  errorSuppl: "#de576d",
  // warning
  warningHover: "#fcb040",
  warningDefault: "#f0a020",
  warningActive: "#c97c10",
  warningSuppl: "#fcb040",
  // success
  successHover: "#36ad6a",
  successDefault: "#18a058",
  successActive: "#0c7a43",
  successSuppl: "#36ad6a"
}, i = s(r.neutralBase), t = s(r.neutralInvertBase), b = `rgba(${t.slice(0, 3).join(", ")}, `;
function p(l) {
  return `${b + String(l)})`;
}
function o(l) {
  const e = Array.from(t);
  return e[3] = Number(l), c(i, e);
}
const g = Object.assign(Object.assign({
  name: "common"
}, n), {
  baseColor: r.neutralBase,
  // primary color
  primaryColor: r.primaryDefault,
  primaryColorHover: r.primaryHover,
  primaryColorPressed: r.primaryActive,
  primaryColorSuppl: r.primarySuppl,
  // info color
  infoColor: r.infoDefault,
  infoColorHover: r.infoHover,
  infoColorPressed: r.infoActive,
  infoColorSuppl: r.infoSuppl,
  // success color
  successColor: r.successDefault,
  successColorHover: r.successHover,
  successColorPressed: r.successActive,
  successColorSuppl: r.successSuppl,
  // warning color
  warningColor: r.warningDefault,
  warningColorHover: r.warningHover,
  warningColorPressed: r.warningActive,
  warningColorSuppl: r.warningSuppl,
  // error color
  errorColor: r.errorDefault,
  errorColorHover: r.errorHover,
  errorColorPressed: r.errorActive,
  errorColorSuppl: r.errorSuppl,
  // text color
  textColorBase: r.neutralTextBase,
  textColor1: "rgb(31, 34, 37)",
  textColor2: "rgb(51, 54, 57)",
  textColor3: "rgb(118, 124, 130)",
  // textColor4: neutral(base.alpha4), // disabled, placeholder, icon
  // textColor5: neutral(base.alpha5),
  textColorDisabled: o(r.alpha4),
  placeholderColor: o(r.alpha4),
  placeholderColorDisabled: o(r.alpha5),
  iconColor: o(r.alpha4),
  iconColorHover: a(o(r.alpha4), {
    lightness: 0.75
  }),
  iconColorPressed: a(o(r.alpha4), {
    lightness: 0.9
  }),
  iconColorDisabled: o(r.alpha5),
  opacity1: r.alpha1,
  opacity2: r.alpha2,
  opacity3: r.alpha3,
  opacity4: r.alpha4,
  opacity5: r.alpha5,
  dividerColor: "rgb(239, 239, 245)",
  borderColor: "rgb(224, 224, 230)",
  // close
  closeIconColor: o(Number(r.alphaClose)),
  closeIconColorHover: o(Number(r.alphaClose)),
  closeIconColorPressed: o(Number(r.alphaClose)),
  closeColorHover: "rgba(0, 0, 0, .09)",
  closeColorPressed: "rgba(0, 0, 0, .13)",
  // clear
  clearColor: o(r.alpha4),
  clearColorHover: a(o(r.alpha4), {
    lightness: 0.75
  }),
  clearColorPressed: a(o(r.alpha4), {
    lightness: 0.9
  }),
  scrollbarColor: p(r.alphaScrollbar),
  scrollbarColorHover: p(r.alphaScrollbarHover),
  scrollbarWidth: "5px",
  scrollbarHeight: "5px",
  scrollbarBorderRadius: "5px",
  progressRailColor: o(r.alphaProgressRail),
  railColor: "rgb(219, 219, 223)",
  popoverColor: r.neutralPopover,
  tableColor: r.neutralCard,
  cardColor: r.neutralCard,
  modalColor: r.neutralModal,
  bodyColor: r.neutralBody,
  tagColor: "#eee",
  avatarColor: o(r.alphaAvatar),
  invertedColor: "rgb(0, 20, 40)",
  inputColor: o(r.alphaInput),
  codeColor: "rgb(244, 244, 248)",
  tabColor: "rgb(247, 247, 250)",
  actionColor: "rgb(250, 250, 252)",
  tableHeaderColor: "rgb(250, 250, 252)",
  hoverColor: "rgb(243, 243, 245)",
  // use color with alpha since it can be nested with header filter & sorter effect
  tableColorHover: "rgba(0, 0, 100, 0.03)",
  tableColorStriped: "rgba(0, 0, 100, 0.02)",
  pressedColor: "rgb(237, 237, 239)",
  opacityDisabled: r.alphaDisabled,
  inputColorDisabled: "rgb(250, 250, 252)",
  // secondary button color
  // can also be used in tertiary button & quaternary button
  buttonColor2: "rgba(46, 51, 56, .05)",
  buttonColor2Hover: "rgba(46, 51, 56, .09)",
  buttonColor2Pressed: "rgba(46, 51, 56, .13)",
  boxShadow1: "0 1px 2px -2px rgba(0, 0, 0, .08), 0 3px 6px 0 rgba(0, 0, 0, .06), 0 5px 12px 4px rgba(0, 0, 0, .04)",
  boxShadow2: "0 3px 6px -4px rgba(0, 0, 0, .12), 0 6px 16px 0 rgba(0, 0, 0, .08), 0 9px 28px 8px rgba(0, 0, 0, .05)",
  boxShadow3: "0 6px 16px -9px rgba(0, 0, 0, .08), 0 9px 28px 0 rgba(0, 0, 0, .05), 0 12px 48px 16px rgba(0, 0, 0, .03)"
});
export {
  g as default
};
